<template>
  <div v-if="model" class="p-ml-2 p-d-flex p-ai-center">
    <LGAvatar :icone="icone" :tamanho="35" />
    <span class="p-ml-2 lg-aa-texto--secundario">
      {{ model.titulo }}
    </span>
  </div>
</template>

<script>
import LGAvatar from 'lg-vue-components/avatar';

export default {
  components: {
    LGAvatar,
  },
  props: {
    model: {
      type: Object,
      default: null,
    },
  },
  computed: {
    icone() {
      if (this.model.icone) {
        return `${this.model.icone} lg-aa-texto--primario-super`;
      }

      return 'pi pi-bookmark lg-aa-texto--primario-super';
    },
  },
};
</script>
